import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.request-center.policies.list', {
        url: '/list',
        component: 'requestCenterPoliciesList',
        resolve: {},
    })
}



// WEBPACK FOOTER //
// ./src/portal/states/company/request-center/policies/list/approval-policies-list.state.js